import { Checkboxes } from "@stacc/flow-ui-components";
import type { Dispatch, SetStateAction } from "react";
import {
  BoldText,
  BoldTextMedium,
  ChecklistWrapper,
  InsuranceWrapper,
  LightSpan,
  TranslationText
} from "../manual-check-final/disbursementCheckStyles";
import {
  additionalChecklistOptions,
  checklistOptions,
  insuranceChecklistOptions
} from "./options";

interface ChecklistProps {
  checklistValues: string[];
  setChecklistValues: Dispatch<SetStateAction<string[]>>;
}

interface ChecklistOption {
  label: string;
  englishLabel: string;
  value: string;
}

// The Finnish variant keeps the original Swedish checklist wording and renders
// the English translation directly beneath each item for Finnish caseworkers.
const withTranslation = (options: ChecklistOption[]) =>
  options.map((option) => ({
    value: option.value,
    label: (
      <span>
        {option.label}
        <TranslationText>{option.englishLabel}</TranslationText>
      </span>
    )
  }));

export const Checklist = ({
  checklistValues,
  setChecklistValues
}: ChecklistProps) => {
  function handleChecklistChange(value: any) {
    if (checklistValues.includes(value)) {
      setChecklistValues(checklistValues.filter((item: any) => item !== value));
      return;
    }
    setChecklistValues([...checklistValues, value]);
  }
  return (
    <div>
      <ChecklistWrapper>
        <BoldText>
          Tarkistuslista
          <TranslationText>Checklist</TranslationText>
        </BoldText>
        <Checkboxes
          options={withTranslation(checklistOptions)}
          name="Checklista"
          onChange={(e: any) => {
            handleChecklistChange(e.target.value);
          }}
          checkedValues={checklistValues}
        />
        <BoldTextMedium>
          Mahdollisesti myös: <LightSpan>(Valinnainen)</LightSpan>
          <TranslationText>Possibly also: (Optional)</TranslationText>
        </BoldTextMedium>
        <Checkboxes
          options={withTranslation(additionalChecklistOptions)}
          name="Ytterligare frågor"
          onChange={(e: any) => {
            handleChecklistChange(e.target.value);
          }}
          checkedValues={checklistValues}
        />
      </ChecklistWrapper>

      <InsuranceWrapper>
        <BoldTextMedium>
          Vakuutus
          <TranslationText>Insurance</TranslationText>
        </BoldTextMedium>
        <Checkboxes
          options={withTranslation(insuranceChecklistOptions)}
          name="Försäkringsfrågor"
          onChange={(e: any) => {
            handleChecklistChange(e.target.value);
          }}
          checkedValues={checklistValues}
        />
      </InsuranceWrapper>
    </div>
  );
};
